import React from "react";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";

import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

const BundleSection = (props, context) => {
  return (
    <Row className="align-items-center bigger-margin-top">
      <Col
        xs={{ size: 12, order: 2 }}
        lg={{ size: 5, order: 1 }}
        className="my-5 text-overlap ps-md-5 px-1"
      >
        <h2 className="text-white mb-4 h1 px-2">{context.t("bundle.title")}</h2>
        <div className="d-flex flex-column justify-content-between">
          <p className={`fw-bold pb-0 px-2`}>{context.t("bundle.text")}</p>
          <small className="text-muted px-2 pb-4 small">
            <a
              href="/Samsung_Aktionsbedingungen.pdf"
              target="_blank"
              rel="noreferrer"
              className="text-muted pb-4 small"
            >
              *{context.t("Terms apply")}
            </a>
          </small>
          <div className="d-grid gap-2 col-md-5 col-12 pt-md-3 px-2">
            <a
              href="https://www.amazon.de/stores/page/50E76ED3-5C4D-4EB4-989A-95C7505F73D1"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary w-100 rounded-pill py-2"
            >
              {context.t("bundle.button")}
            </a>
          </div>
        </div>
      </Col>
      <Col
        xs={{ size: 12, order: 1 }}
        lg={{ size: 7, order: 2 }}
        className="my-5 pt-5 pt-md-0"
      >
        <img
          src={
            (REACT_APP_CDN_PATH || "") +
            "/images/bundle/630x400_Motiv_4_Right.png"
          }
          alt="samsung"
          height={"100%"}
          width="100%"
          style={{ maxWidth: "630px", maxHeight: "400px" }}
          className="align-self-end"
        />
      </Col>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
BundleSection.contextTypes = {
  t: PropTypes.func,
};

BundleSection.propTypes = {};

BundleSection.defaultProps = {};

export default BundleSection;
